{
  "ACESSELHIS": "/aces/view-aces-history",
  "TASKMODALT": "/task/view-task",
  "EMSGSELERM": "/emsg/view",
  "EMSGMODEMD": "/emsg/edit",
  "CBATSELBAT": "/cbat/view",
  "CBATSELIRS": "/cbat/irs-collection",
  "CBATMODDFD": "/cbat/irs-approve",
  "CRECSELVRC": "/crec/view-recoupment",
  "CRECSELNRC": "/crec/view-nsf-recoupment",
  "CRECMODLTH": "/crec/edit-recoupment",
  "CRECMODRCB": "/crec/modify-recoupment",
  "CRECMODRCP": "/crec/update-recoupment",
  "BHISSELBST": "/bhis/view-billing-statements",
  "BHISSELBSO": "/bhis/view-billing-suppression-override",
  "BHISMODREP": "/bhis/view-request-reprint",
  "BHISSELMSG": "/bhis/view-global-messages",
  "BHISMODBSO": "/bhis/edit-add-billing-suppression-override",
  "BHISMODMSG": "/bhis/edit-add-global-message",
  "DSBVMODDBC": "/dsbv/void-case",
  "DSBVMODDCN": "/dsbv/void-check",
  "DSBVMODDFR": "/dsbv/void-recipient",
  "DSBVSELDBC": "/dsbv/view-case",
  "DSBVSELDCN": "/dsbv/view-check",
  "DSBVSELDFR": "/dsbv/view-recipient",
  "GTSTADDGTD": "/gtst/add-case",
  "GTSTMODGTD": "/gtst/edit-case",
  "GTSTSELTDC": "/gtst/view-case",
  "GTSTSELTDM": "/gtst/view-member",
  "INEXSELEXP": "inex/view",
  "INEXADDEXP": "inex/add",
  "INEXMODEXP": "inex/edit",
  "KCALADDHOL": "/kcal/add-holiday",
  "KCALMODHOL": "/kcal/edit-holiday",
  "KCALMODMCL": "/kcal/edit-calendar",
  "KCALSELMCL": "/kcal/view-calendar",
  "KCALSELVHL": "/kcal/view-holiday",
  "ACTVMODMAA": "/actv/major/edit",
  "ACTVMODMNA": "/actv/minor/edit",
  "ACTVSELMAA": "/actv/major",
  "ACTVSELMNA": "/actv/minor",
  "EHISSELAVS": "/ehis/view",
  "EHISADDAVS": "/ehis/add",
  "EHISMODAVS": "/ehis/edit",
  "BWLTSELCSE": "/bwlt/warrant-case/view",
  "BWLTMODCSE": "/bwlt/warrant-case/edit",
  "BWLTSELCTY": "/bwlt/warrant-country/view",
  "BWLTMODCTY": "/bwlt/warrant-country/edit",
  "BWLTSELDCN": "/bwlt/warrant-dcn/view",
  "BWLTMODDCN": "/bwlt/warrant-dcn/edit",
  "DHLDMODHCD": "/dhld/holdcase",
  "DHLDMODHRD": "/dhld/holdrecipient",
  "DHLDMODRCD": "/dhld/releasecase",
  "DHLDMODRRD": "/dhld/releaserecipient",
  "DHLDSELCSD": "/dhld/viewcase",
  "DHLDSELRDB": "/dhld/viewrecipient",
  "HLDISELDSH": "/hldi/view-dist-hold",
  "HLDIADDDSH": "/hldi/add-dist-hold",
  "HLDIMODTHI": "/hldi/terminate-hold",
  "HLDISELDBH": "/hldi/view-disb-hold",
  "HLDIADDDBH": "/hldi/add-disb-hold",
  "HLDIMODEHI": "/hldi/extend-hold",
  "RHISSELRCT": "/rhis/view-all-receipt",
  "RHISSELPYH": "/rhis/payment-history",
  "RHISSELRVR": "/rhis/reversed-receipt",
  "RHISSELREE": "/rhis/receipt-escheatment",
  "NOTEADDCCN": "/note/confidentialnote",
  "NOTEADDCSN": "/note/customerservice",
  "NOTEADDCFN": "/note/financialnote",
  "NOTEADDNFN": "/note/createnote",
  "NOTEADDRPT": "/note/notereport",
  "BSTLDELSOI": "/bstl/delete-soil-rejects",
  "BSTLSELBER": "/bstl/error",
  "NOTEMODNON": "note/view",
  "BSTLSELBSL": "/bstl/status-log",
  "BSTLSELFMS": "/bstl/fact-messages",
  "BSTLSELPQE": "/bstl/print-queue",
  "BSTLSELSOI": "/bstl/soil-rejects",
  "SLOGSELBHN": "slog/ncp",
  "SLOGSELBHC": "slog/caseId",
  "AHISSELADH": "/ahis/view-address",
  "MLICSELMLC": "plic/view",
  "MLICADDMLC": "plic/add",
  "MLICMODMLC": "plic/edit",
  "EFTISELICP": "/efti/cp/view",
  "EFTISELIFP": "/efti/fips/view",
  "EFTISELIOA": "/efti/agencies/view",
  "EFTIMODIFP": "/efti/fips/edit-add",
  "EFTIMODIOA": "/efti/agencies/edit-add",
  "AHISADDAVS": "/ahis/add-address",
  "AHISMODAVS": "/ahis/edit-address",
  "AHISMIIDAS": "/ahis/edit-identity",
  "RPOSDELUDR": "/rpos/update-delete-receipts",
  "RPOSMODARR": "/rpos/approve-receipts",
  "RPOSMODRPR": "/rpos/repost-receipts",
  "RPOSSELRPR": "/rpos/reposted-receipts",
  "USEMSELUPF": "/usem/view-profile",
  "USEMADDUPF": "/usem/add-profile",
  "USEMMODUPF": "/usem/update-profile",
  "USEMSELASM": "/usem/user-assign",
  "USEMSELRSM": "/usem/user-reassign",
  "MHISMODMPH": "/mhis/edit/ivdmember",
  "MHISSEL4DC": "/mhis/ivd/case",
  "MHISSEL4DM": "/mhis/ivd/member",
  "MHISSELAEC": "/mhis/ivdive/case",
  "MHISSELAEM": "/mhis/ivdive/member",
  "MHISSELDKT": "/mhis/history/docket",
  "OTHPSELOPI": "/othp/view-othp",
  "OTHPADDOPI": "/othp/add-othp",
  "OTHPMODOPI": "/othp/edit-othp",
  "OTHPADDANM": "/othp/add-non-members",
  "OTHPSELEMP": "/othp/view-emp-list",
  "CCRTSELAPP": "/ccrt/view",
  "CCRTADDCSE": "/ccrt/case",
  "CCRTMODCSE": "/ccrt/edit",
  "CCRTADDFCT": "/ccrt/view",
  "CCRTBKLDDF": "/ccrt/view",
  "DARRSELDRR": "/darr/view",
  "ASMTMODCAO": "/asmt/transfercase",
  "ASMTMODMAR": "/asmt/createalpha",
  "ASMTMODRCW": "/asmt/reassignnewcase",
  "ASMTMODREW": "/asmt/reassignexistcase",
  "DIRRSELNJA": "/dirr/agency-disb",
  "DIRRSELDBR": "/dirr/disb-register",
  "DIRRSELCPW": "/dirr/cwa-recoupment",
  "CPROMODENF": "/cpro/view-enforcement",
  "CPDRSELPRF": "/cpdr/view-cpdr",
  "CPDRDELPRF": "/cpdr/delete-cpdr",
  "COMPADDCSH": "/comp/add-comp",
  "COMPMODCSH": "/comp/update-comp",
  "COMPSELCSH": "/comp/view-comp",
  "PARMSELBPR": "/parm/batch",
  "PARMMODBPR": "/parm/updatebatch",
  "SORDSELCTO": "/sord/view-sord",
  "SORDADDCTO": "/sord/add-initial-sord",
  "SORDMODCTO": "/sord/edit-initial-sord",
  "SORDMODCCO": "/sord/edit-existing-sord",
  "SORDMODCTM": "/sord/edit-sord-modification",
  "COPTSELCOP": "/copt/options",
  "COPTMODCOP": "/copt/update",
  "SPROSELSPR": "/spro/view-proceedings",
  "SPROMODSPR": "/spro/update-proceedings",
  "SPROADDSNP": "/spro/add-proceedings",
  "SRCHSELCSE": "/srch/search-njkids",
  "SRCHSELACS": "/srch/search-cases",
  "RSTRADDRCM": "/rstr/add-restricted-by-case",
  "RSTRADDRWK": "/rstr/add-restricted-by-worker",
  "RSTRMODRCM": "/rstr/end-date-restricted-by-case",
  "RSTRMODRWK": "/rstr/end-date-restricted-by-worker",
  "RSTRSELRCM": "/rstr/restricted-by-case",
  "RSTRSELRWK": "/rstr/restricted-by-worker",
  "ANXTSELACT": "/anxt/next-activity",
  "ANXTMODACT": "/anxt/update-associate-doc",
  "ANXTDELACT": "/anxt/delete-next-activity",
  "LPROADDINF": "/lpro/addr",
  "LPROEMPINF": "/lpro/empl",
  "LPROOTHINF": "/lpro/othr",
  "CPIMSELCPI": "/cpim/view-cpim",
  "CPIMMODCPI": "/cpim/add-update-cpim",
  "MASTMODMAS": "/mast/update-member",
  "MASTADDFAS": "/mast/add-financial",
  "MASTADDVAS": "/mast/add-vehicle",
  "MASTADDSAS": "/mast/add-settlement",
  "MASTADDINA": "/mast/add-insurance",
  "MASTADDPAS": "/mast/add-realproperty",
  "ICORSELCSE": "/icor/view-csenet-errors",
  "ICORSELICH": "/icor/view-correspondence",
  "ICORSELSPL": "/icor/view-quick-locate",
  "ICORMODADY": "/icor/view-assist-discovery",
  "ICORMODWRF": "/icor/view-worklist-referrals",
  "BATRSELBRT": "/batr/batch-receipt",
  "IMCLSELFCK": "/imcl/view-imcl",
  "IMCLMODFCK": "/imcl/update-imcl",
  "CCRTSELCSE": "/csum/case-summary",
  "DPCRSELDPC": "/dpcr/view-dpcr",
  "REFMADDRCD": "/refm/add-reference",
  "REFMDELRCD": "/refm/delete-reference",
  "REFMMODGLN": "/refm/edit-guidline",
  "REFMMODRCD": "/refm/edit-reference",
  "REFMSELGLN": "/refm/view-guidline",
  "REFMSELRCD": "/refm/view-reference",
  "WRKLSELUNR": "/wrkl/unidentified-alerts",
  "WRKLSELJPR": "/wrkl/update-judge-proceedings",
  "WRKLSELUAL": "/wrkl/hold-release-alerts",
  "STAFSELSDE": "/staf/staff-data-entry",
  "STAFADDSDE": "/staf/add-staff-data-entry",
  "STAFMODSDE": "/staf/update-staff-data-entry",
  "ISNDSELICR": "/isnd/add-correspondence",
  "IWNSSELIWC": "/iwns/view-iwns-by-case",
  "IWNSMODIWC": "/iwns/update-iwns",
  "IWNS0003": "/iwns/view-iwns-by-soi",
  "DRARSELDRA": "/drar/drar-page",
  "DDARSELDDA": "/ddar/ddar-page",
  "TAXISELOIM": "/taxi/taxdcn",
  "TAXISELOIS": "/taxi/taxssn",
  "TAXIREPORT": "/taxi/report",
  "TAXISELSIM": "/taxi/soildcn",
  "TAXISELSIS": "/taxi/soilssn",
  "TAXIMODTEX": "/taxi/update",
  "DHATSELDHR": "/dhat/recipient",
  "DHATSELDHC": "/dhat/case",
  "SVCISELSVC": "/svci/view-instructions",
  "SVCIMODSVC": "/svci/edit-instructions",
  "SVCIADDSVC": "/svci/add-instructions",
  "RDCRSELRFD": "/rdcr/view-refunds",
  "REFTSELTTS": "/reft/eft-transfer-totals",
  "REFTSELVEP": "/reft/electronic-payment-activity",
  "REFTSELDCR": "/reft/daily-eft-changes",
  "MDINADDINS": "/mdin/add-ins",
  "MDINMODINS": "/mdin/update-ins",
  "MDINSELIND": "/mdin/ins-by-dependent",
  "MDINSELIOP": "/mdin/ins-by-order",
  "ISINADDIIN": "/isin/add-isin",
  "ISINMODICR": "/isin/edit-icr",
  "ISINMODIIN": "/isin/edit-isin",
  "ISINSELIIN": "/isin/view-isin",
  "FINSSELREC": "/fins/view-sdu-reconcil-bal",
  "FINSSELFNS": "/fins/view-financial-summary",
  "FINSMODREC": "/fins/update-sdu-reconcil-bal"
}
